import { takeEvery } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import { sendTemplate, uploadInBulk } from "../slices";
import { toastError } from "../../utils/react-toaster";
import { BULK_TYPE } from "../../data/constants";
import {
  getErrorMessage,
  pos_errormap_with_label,
} from "../../helpers/errors-helper";
import { METHODS } from "../../data/api-method-constants";
export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: any;
}

const BULK_ACTION_UPLOAD_DATA_MAP = {
  [BULK_TYPE.bulk_price]: ENDPOINT.BULK_UPLOAD.uploadBulkPriceApi,
  [BULK_TYPE.bulk_item]: ENDPOINT.BULK_UPLOAD.uploadItemDataApi,
  [BULK_TYPE.bulk_item_setting]: ENDPOINT.BULK_UPLOAD.uploadBulkItemSettingsApi,
  [BULK_TYPE.bulk_add_ons]: ENDPOINT.BULK_UPLOAD.bulkUploadOptionSetApi,
  [BULK_TYPE.bulk_add_ons_update]: ENDPOINT.BULK_UPLOAD.bulkUpdateOptionSetApi,
  [BULK_TYPE.bulk_item_delete]: ENDPOINT.BULK_UPLOAD.uploadItemDeleteDataApi,
}

const BULK_ACTION_SEND_TEMPLATE_DATA_MAP = {
  [BULK_TYPE.bulk_price]: ENDPOINT.BULK_UPLOAD.sendPriceTemplate,
  [BULK_TYPE.bulk_item]: ENDPOINT.BULK_UPLOAD.sendItemTemplateApi,
  [BULK_TYPE.bulk_item_setting]: ENDPOINT.BULK_UPLOAD.sendItemSettingsTemplate,
  [BULK_TYPE.bulk_add_ons]: ENDPOINT.BULK_UPLOAD.sendAddOnsTemplateApi,
  [BULK_TYPE.bulk_add_ons_update]:
    ENDPOINT.BULK_UPLOAD.sendUpdateAddonsTemplateApi,
  [BULK_TYPE.bulk_item_delete]: ENDPOINT.BULK_UPLOAD.sendItemDeleteTemplateApi,
};

function* uploadBulkData(actions: any) {
  let type = actions.payload.type,
    apiUrl =
      BULK_ACTION_UPLOAD_DATA_MAP[type] ||
      ENDPOINT.BULK_UPLOAD.uploadBulkImageApi;
  try {
    const response: ResponseGenerator = yield api.request({
      method: METHODS.POST,
      url: apiUrl,
      data: actions.payload.dataToPost,
    });
    if (!response?.code) {
      actions.payload?.callback && actions.payload.callback(response);
    } else if (pos_errormap_with_label[response?.code]) {
      toastError(
        getErrorMessage(
          pos_errormap_with_label,
          response?.code,
          actions.payload?.userEmail
        )
      );
    }
  } catch (error) {
    toastError("Please try again!");
    console.log(error);
  }
}

function* sendTemplateData(actions: any) {
  let apiMethod = METHODS.GET,
    type = actions.payload.type,
    apiUrl =
      BULK_ACTION_SEND_TEMPLATE_DATA_MAP[type] ||
      ENDPOINT.BULK_UPLOAD.sendImageTemplateApi,
    dataToPost = {};
  
  if (
    type === BULK_TYPE.bulk_price ||
    type === BULK_TYPE.bulk_item_setting ||
    type === BULK_TYPE.bulk_add_ons_update
  ) {
    apiMethod = METHODS.POST;
    dataToPost = actions.payload.dataToPost;
  }
  try {
    const response: ResponseGenerator = yield api.request({
      method: apiMethod,
      url: apiUrl,
      params: dataToPost,
    });
    if (response?.code) toastError("Please try again!");
    else actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(uploadInBulk.type, uploadBulkData);
  yield takeEvery(sendTemplate.type, sendTemplateData);
}
